import { DocsReaderPageComponent } from '@mercedes-benz/plugin-techdocs';

export const TechdocsContent = <DocsReaderPageComponent />;
